export class Vk {


    eventInit(eventName, params) {
        window.vkAsyncInit = function() {
            VK.Retargeting.Init('VK-RTRG-355888-7PGvs');
            VK.Retargeting.ProductEvent(3440, eventName, params);
        };
    }

    productPageView(product) {
        this.eventInit('view_product', {
            'products': [{id: product.id}],
            'total_price': product.price
        });
    }

    basketPageView(basket) {
        let ids = [], totalPrice = 0.0;

        basket.forEach(product => {
            ids.push({'id': product.id});
            totalPrice += parseFloat(product.price) * product.quantity;
        });
        this.eventInit('add_to_cart', {
            'products': ids,
            'total_price': totalPrice
        });
    }

    orderThankyouPageView(basket)
    {
        let ids = [], totalPrice = 0.0;

        basket.forEach(product => {
            ids.push({'id': product.id});
            totalPrice += parseFloat(product.price) * product.quantity;
        });

        this.eventInit('purchase', {
            'products': ids,
            'total_price': totalPrice
        });
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/vk.js